import cseLogo from '../Assets/cselogo.png';
import professional from '../Assets/professional.png';
import subprofessional from '../Assets/subprofessional.png';
import verbal from '../Assets/verbal.png';
import analytical from '../Assets/analytical.png';
import clerical from '../Assets/clerical.png';
import numerical from '../Assets/numerical.png';
import general from '../Assets/general.png';
import demo from '../Assets/demo.png';

/**
 * Map logo filename (from API) to bundled asset.
 */
export const REVIEWER_LOGO_MAP = {
  'cselogo.png': cseLogo,
};

export const BANNER_IMAGE_MAP = {
  'professional.png': professional,
  'subprofessional.png': subprofessional,
  'verbal.png': verbal,
  'analytical.png': analytical,
  'clerical.png': clerical,
  'numerical.png': numerical,
  'general.png': general,
  'demo.png': demo,
};
/**
 * Shared important notes for exam details (CSE). Used across reviewers.
 */
export const EXAM_IMPORTANT_NOTES = [
  { title: '⏱️ Time Management is Key', text: 'The exam is 3 hours and 10 minutes long. Use your time wisely—pace yourself and avoid spending too long on any single question.' },
  { title: '❌ No "Negative Marking"', text: "Don't be afraid to guess. You won't lose points for wrong answers, so try to answer every question." },
  { title: '💡 You can skip questions', text: 'Navigate freely and come back to difficult items later. Use the question list to track your progress.' },
  { title: '✅ Review your answers', text: "After completion you'll get your score and a detailed breakdown by subject. Use this to focus your review." },
  { title: '🎯 Simulate the actual environment', text: 'Find a quiet space and minimize distractions. Practicing under exam-like conditions helps build confidence.' },
  { title: '🔍 Answer Review Available', text: 'After the exam, correct answers and explanations are available so you can learn from every question.' },
  { title: '🧠 Heads up!', text: 'Questions are uniquely generated by BrainyBesh.ai to give you a fresh practice experience each time.' },
];

/**
 * Coming soon exams – static list for Home "Coming Soon" section.
 */
export const COMING_SOON_EXAMS = [
  { name: '👩🏻‍🏫 LET – Licensure Exam for Teachers' },
  { name: '⚕️ NLE – Nursing Licensure Exam' },
  { name: '🧠 Psychometrician Licensure Exam' },
  { name: '👮🏻‍♀️ Criminology Licensure Exam (CLE)' },
  { name: '👩🏻‍🎓 UPCAT and big entrance tests like ACET/USTET' },
  { name: '🧑🏻‍💼 CHRA – Certified Human Resource Associate Exam' },
];
